<template>
    <div class="img__holder" >
        <img class="h-auto w-auto" :src="image" :alt="(description ? description : title) + ' - ' + credit" :class="className"/>
        <transition name="fade">
            <div class="img__caption" >
                <div class="img__inner">
                    <div class="img__title">{{ title }}</div>
                    <div class="img__credit" v-if="credit">&copy; {{ credit}}</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    import ScreenSize from "../../../mixins/screen-size";

    export default {
        name: "Slide",
        mixins: [ScreenSize],
        props: {
            image: null,
            title: '',
            credit: '',
            description: ''
        },
        data: () => {
            return {
                className: 'img__fluid',
                show: true,
                interval: null,
                mobile: false,
                tablet: false
            }
        },
        mounted() {
            if (this.isDesktop) {
                this.show = false
            }
            this.getClassName();
        },
        created() {
            /*window.addEventListener('resize', this.handleResize);
            this.handleResize();*/
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            showCaption() {
                if (!this.show) {
                    this.show = true;
                    clearInterval(this.interval);
                    setInterval(() => {
                        this.show = false;
                        clearInterval(this.interval);
                    }, 50000)
                }
            },
            handleResize() {
                this.mobile = false;
                if (window.innerWidth <= 768) {
                    this.mobile = true;
                }
            },
            getClassName() {
                if (!this.mobile) {
                    let image = new Image();
                    image.onload = () => {
                        let height = image.naturalHeight;
                        let width = image.naturalWidth;
                        if (height >= 400 && width >= 400) {
                            //get orientation
                            if (height >= width) {
                                //vertical image
                                this.className = 'img__vertical';
                            } else {
                                if (width / height > 1.8) {
                                    //large image
                                    this.className = 'img__horizontal_large';
                                } else {
                                    this.className = 'img__horizontal';
                                }
                            }
                        }
                    };
                    image.src = this.image
                }
            }
        }
    }
</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 250ms ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>

